"use strict";Object.defineProperty(exports,"__esModule",{value:true});exports.default=void 0;function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function")}}function _defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor)}}function _createClass(Constructor,protoProps,staticProps){if(protoProps)_defineProperties(Constructor.prototype,protoProps);if(staticProps)_defineProperties(Constructor,staticProps);Object.defineProperty(Constructor,"prototype",{writable:false});return Constructor}var ONE=1;var TWO=2;/**
 * @class ./services/Domain
 */var Domain=/*#__PURE__*/function(){/**
     * @type {String}
     */ /**
     * Constructor.
     *
     * @param {String} customDomainName
     */function Domain(customDomainName){_classCallCheck(this,Domain);this.domainName=customDomainName?customDomainName:window.location.host}/**
     * Returns an array of available domains.
     *
     * @returns {Array}
     */_createClass(Domain,[{key:"getDomains",value:function getDomains(){return this.domainName.split(".")}/**
     * Returns only domain.
     *
     * @returns {String}
     */},{key:"getDomain",value:function getDomain(){var domains=this.getDomains();return domains.slice(domains.length-TWO,domains.length-ONE).join(".")}/**
     * Returns top level domain.
     *
     * @returns {String}
     */},{key:"getTopLevelDomain",value:function getTopLevelDomain(){var domains=this.getDomains();return domains[domains.length-ONE]}/**
     * Returns true if url is subdomain.
     *
     * @returns {Boolean}
     */},{key:"isSubDomain",value:function isSubDomain(){return this.getDomains().length>TWO}}]);return Domain}();var _default=Domain;exports.default=_default;